export function cleanString(notificationMessage){
    notificationMessage='Hi, '.concat(notificationMessage)
    let finalString=''
    let i=0;
    let firstCharacter=0
    let excludedOnes=['Hi!,','Hi']
    let a = notificationMessage.split(' ')
    for(i=0;i<a.length;i++)
    {
        if(!excludedOnes.includes(a[i]))
        {
            if(firstCharacter==0)
            {
                let temp
                temp=a[i].split('')
                temp[0]=temp[0].toUpperCase()
                a[i]=temp.join('')
                firstCharacter++
            }
            finalString = finalString.concat(`${a[i]} `)
        }
    }
    return finalString
}


// WEBPACK FOOTER //
// ./src/Components/AlertDropdown/utils.js